import { ReactComponent as Facebook } from "../assets/landing/svg/facebook.svg";
import { ReactComponent as Twitter } from "../assets/landing/svg/twitter.svg";
import { ReactComponent as Linkedin } from "../assets/landing/svg/linkedin.svg";
import { ReactComponent as Instagram } from "../assets/landing/svg/instagram.svg";
import { ReactComponent as Tiktok } from "../assets/landing/svg/tiktok.svg";

export const footerDocLinks = [
  { label: "Terms & Conditions", path: "/terms-conditions" },
  { label: "Privacy Policy", path: "/privacy-policy" },
];

export const mainFooterDocLinks = [
  { label: "Home", path: "/" },
  { label: "Public Safety", path: "/public-safety" },
  { label: "Our Approach", path: "/our-approach" },
  { label: "Who We Are", path: "/who-we-are" },
  { label: "Contact Us", path: "/contact-us" },
];

export const mainFooterLinks = [
  {
    path: "/",
    icon: <Facebook />,
  },
  {
    path: "/",
    icon: <Instagram />,
  },
  {
    path: "/",
    icon: <Linkedin />,
  },
  {
    path: "/",
    icon: <Tiktok />,
  },
];

export const bgAndBorder = [
  {
    type: "Sa",
    bg: "linear-gradient(0deg, #FCF0FF 50%, rgba(232, 244, 252, 0) 100%)",
    border: "#8B3F9E",
  },
  {
    type: "Re",
    bg: " linear-gradient(0deg, #E6F1FA 50%, rgba(255, 247, 244, 0) 100%)",
    border: "#1780C6",
  },
  {
    type: "Ga",
    bg: "linear-gradient(0deg, #FFF2EB 50%, rgba(251, 238, 255, 0) 100%)",
    border: "#FFB142",
  },
  {
    type: "Ma",
    bg: "linear-gradient(0deg, #F0F9F2 50%, rgba(242, 231, 245, 0) 100%)",
    border: "#2D8F4E",
  },
];
